// extracted by css-extract-rspack-plugin
export default {"card":"I2Te_","list":"GB8nD"};